import { render, staticRenderFns } from "./OrderPaymentOptions.vue?vue&type=template&id=74c2086c"
import script from "./OrderPaymentOptions.vue?vue&type=script&lang=js"
export * from "./OrderPaymentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports